import { RecaptchaProvider } from 'components/RecaptchaProvider';
import { HandleSocialLoginCallback } from 'features/social/HandleSocialLoginCallback';

export const SocialLoginCallbackPage = () => (
  <RecaptchaProvider>
    <HandleSocialLoginCallback />
  </RecaptchaProvider>
);
